import { observable, action, runInAction } from 'mobx';
import FirebaseUserService from '../services/impl/firebase/FirebaseUserService';
import { toast } from "react-toastify"
import IActivity, { IActivityFilter, IActivityCollection, newActivityFilterInstance } from '../types/IActivity';
import IActivityService from '../services/spi/IActivityService';
import FirebaseActivityService from '../services/impl/firebase/FirebaseActivityService';
import ICustomer, { newCustFilterInstance, ICustomerCollection } from '../types/ICustomer';
import IDocument, { IDocumentCollection, IDocumentFilter, newDocFilterInstance } from '../types/IDocument';
import ICustomerService from '../services/spi/ICustomerService';
import FirebaseCustomerService from '../services/impl/firebase/FirebaseCustomerService';
import IDocumentService from '../services/spi/IDocumentService';
import FirebaseDocumentService from '../services/impl/firebase/FirebaseDocumentService';
import IPaginator, { IPaginatorQueryType, newPaginatorInstance } from '../types/Paginator';
import IListService from '../services/spi/IListService';
import FirebaseListService from '../services/impl/firebase/FirebaseListService';
import IList, { IListItem } from '../types/IList';

interface IActivitySideBarModel {
  timeline: Array<any>,
  event:Array<any>,
  customerId: string|null|undefined,
  contentId: string|null|undefined
}

const ROWS_PER_PAGE = 5;

class ActivityStore{
  rootStore: any;
  @observable screen = {
    isLoading: false
  };
  @observable activityCollection:IActivityCollection = {
    activities: [],
    paginator: newPaginatorInstance(20)
  };
  @observable customers:Array<ICustomer> = [];
  @observable documents: Array<IDocument> = [];

  /*@observable activitySideBarModel:IActivitySideBarModel = {
    timeline: [
      {name: 'Today', label: 'Today', selected: false},
      {name: 'Yesterday', label: 'Yesterday', selected: false},
      {name: '7days', label: '7 Days', selected: false},
      {name: '15days', label: '15 Days', selected: false},
      {name: '30days', label: '30 Days', selected: false}
    ],
    event: [
      {name: 'ALL', label:'All', selected: false},
      {name: 'MeetingAttended', label:'Attended', selected: false},
      {name: 'ContentShared', label:'Shared', selected: false},
      {name: 'ContentVisited', label:'Visited', selected: false},
      {name: 'MeetingInvited', label:'Invited', selected: false},
    ],
    customerId: null ,
    contentId: null
  }*/
  @observable timelineList = [] as Array<IListItem>;
  @observable eventList = [] as Array<IListItem>;
  @observable activityFilter = {} as IActivityFilter;
  @observable activityPaginator = {} as IPaginator;
  
  activityService = {} as IActivityService;
  listService = {} as IListService;
  customerService: ICustomerService = {} as ICustomerService;
  documentService: IDocumentService = {} as IDocumentService;

  constructor(rootStore:any) {
    this.rootStore = rootStore
    this.activityService = new FirebaseActivityService();
    this.customerService = new FirebaseCustomerService();
    this.documentService = new FirebaseDocumentService();
    this.listService = new FirebaseListService();
    this.activityFilter = newActivityFilterInstance();
    this.activityPaginator = newPaginatorInstance(20);
  }


  @action loadActivities = async () => {
    try{
      this.screen.isLoading = true; 
      this.activityCollection = await this.activityService.getActivities(this.activityPaginator, this.activityFilter);
      this.activityPaginator = this.activityCollection.paginator;
      this.screen.isLoading = false;
    }catch(e){
      this.screen.isLoading = false;
      toast.error("Error loading Activities. ");
    }
  }

  @action loadSideBarFilterData = async () => {
    try{
      const eventList:IList = await this.listService.getList("ACTIVITY_TYPES");
      this.eventList = eventList.options;
      const timelineList:IList = await this.listService.getList("ACTIVITY_TIMELINE");
      this.timelineList = timelineList.options;
    }catch(e){
      debugger
      toast.error("Couldnot load filter data");
    }
  }

  @action setActivityFilter(filter?:Partial<IActivityFilter>, added?:boolean){
    this.activityFilter = {...this.activityFilter, ...filter};
    this.activityFilter = newActivityFilterInstance();
   }
 
   @action setPaginator(paginator:Partial<IPaginator>){
     this.activityPaginator = Object.assign(this.activityPaginator, paginator);
   }

  @action loadCustomers = async () => {
    const custCollection: ICustomerCollection = await this.customerService.getCustomers(newPaginatorInstance(), newCustFilterInstance());
    this.customers = custCollection.customers;
  }

  @action loadDocuments = async () => {
    const docCollection: IDocumentCollection = await this.documentService.getDocuments(newPaginatorInstance(), newDocFilterInstance());
    this.documents = docCollection.documents;
  }

  /*private updateSideBarState(filter?:IActivityFilter){
    this.activitySideBarModel.event = this.activitySideBarModel.event.map(ev => {
      ev.selected = filter ? (filter.activityType === ev.name ? true : false) : false;
      return ev;
    });
    
    this.activitySideBarModel.timeline = this.activitySideBarModel.timeline.map(tl => {
      tl.selected = filter ? (filter.timeline === tl.name ? true : false) : false;
      return tl;
    });

    this.activitySideBarModel.customerId = (filter ? filter.customerId : null);
    this.activitySideBarModel.contentId = (filter ? filter.contentId : null);
  }*/

  @action clearAllFilters(){
    //this.updateSideBarState(this.activityFilter);
    this.setActivityFilter(newActivityFilterInstance());
  }

}

export default ActivityStore;
